export default class Tickets {
	constructor(el) {
		this.el = el;
		this.faqQuestions = this.el.querySelectorAll(".tickets__faq-question");
		this.faqAnswers = this.el.querySelectorAll(".tickets__faq-answer");

		this.onClickFaqToggle = this.onClickFaqToggle.bind(this);

		this.faqQuestions[0].parentNode.classList.add("tickets__faq--visible");

		this.faqQuestions.forEach(
			(el) => el.addEventListener("click", this.onClickFaqToggle),
			false
		);
	}

	onClickFaqToggle(e) {
		e.target.parentNode.classList.toggle("tickets__faq--visible");
	}
}
